import ReactMarkdown from "react-markdown";
import markdownUrl from "../../assets/intro.md";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import BrandLogo from "../../components/BrandLogo";
import { MARKET_TABS, resolveMarketKey } from "../../utils/marketTab";

export function WelcomePage() {
  const [markdownContent, setMarkdownContent] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const selectedTab = resolveMarketKey(location.pathname, location.search);

  useEffect(() => {
    fetch(markdownUrl)
      .then((response) => response.text())
      .then((data) => setMarkdownContent(data));
  }, []);

  const acknowledge = () => {
    const target = MARKET_TABS.find((tab) => tab.value === selectedTab) || MARKET_TABS[1];
    navigate(target.path);
  };

  return (
    <div className="w-full h-full overflow-auto">
      <div className="mx-auto w-full max-w-[1080px] px-4 py-6 pb-24 md:px-8 md:py-10">
        <header className="text-center">
          <h1 className="brand-title text-[22px] font-semibold leading-[1.3] tracking-[0.06em] text-[#EDE3CB] md:text-[28px]">
            Time Series Model Research
          </h1>
          <div className="mt-3 flex items-center justify-center gap-2 text-[9px] uppercase tracking-[0.28em] text-[#8A7A56]">
            <span className="status-dot" />
            量化终端 · 多因子时序信号
          </div>
        </header>

        <div className="panel mt-8 px-4 py-6 md:px-8 md:py-8">
          <div className="text-center">
            <div className="relative inline-block">
              <div className="absolute inset-0 rounded-[22px] bg-[#D4AF37]/18 blur-2xl" />
              <BrandLogo className="relative drop-shadow-[0_10px_30px_rgba(0,0,0,0.55)]" size={isMobile ? 76 : 96} />
            </div>
          </div>
          <div className="markdown-body mt-6 text-left">
            <ReactMarkdown
              children={markdownContent}
            />
          </div>
        </div>

        <footer className="py-6 text-center text-[10px] tracking-[0.08em] text-[#5F5B54]">
          粤ICP备2026054831号-1
        </footer>
      </div>

      {isMobile && (
        <button className="acknowledge-fab" onClick={acknowledge} type="button">
          我已知晓
          <svg aria-hidden="true" fill="none" height="13" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="13">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </button>
      )}
    </div>
  );
}
